export const ADD_DOCTORS_BY_CLIENT_COMPANY_REQUEST = 'ADD_DOCTORS_BY_CLIENT_COMPANY_REQUEST';
export const ADD_DOCTORS_BY_CLIENT_COMPANY_SUCCESS = 'ADD_DOCTORS_BY_CLIENT_COMPANY_SUCCESS';
export const ADD_DOCTORS_BY_CLIENT_COMPANY_FAILURE = 'ADD_DOCTORS_BY_CLIENT_COMPANY_FAILURE';